var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestopsIconEnterprise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo TestOps Enterprise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 120H61.2072L50.3176 111.489L120 0H0V120Z",
    fill: "#57CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.998 120H52.9353L27.998 80.0843L70.759 41.5385L119.998 120Z",
    fill: "#4D94FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5789 24H62.2038C69.045 24 75.607 26.7182 80.4448 31.5552C85.2818 36.3939 88 42.955 88 49.7962V88.4211C88 90.3975 86.3975 92 84.4211 92H45.7962C38.955 92 32.3939 89.2818 27.5561 84.4449C22.7182 79.607 20 73.0459 20 66.2039V27.579C20 25.6025 21.6025 24 23.5789 24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TE",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0034 65.6V72H55.9976V44H76.0034V50.4H63.9886V54.8H71.9921V60.8H63.9886V65.6H76.0034ZM43.8579 50.8003V72.0003H36.2579V50.8003H27.998V44.0003H51.998V50.8003H43.8579Z",
    fill: "#3194FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsIconEnterprise);
export default __webpack_public_path__ + "static/media/testops_icon_enterprise.9ced98ecc0f411ad5f6dcd0a41a69130.svg";
export { ForwardRef as ReactComponent };